import { css } from "styled-components";
import { theme } from "../theme";

export const ScrollbarStyle = css`
  scrollbar-width: thin;
  scrollbar-color: ${theme.colors.gray400} ${theme.colors.gray200};

  &::-webkit-scrollbar {
    border-radius: 20px;
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background-color: ${theme.colors.white};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.gray200};
    border-radius: 20px;
  }
`;
